import { Button } from '@heroui/react';
import { useNavigate } from 'react-router-dom';
import { Section } from '@/shared/ui/Section';
import { routerPath } from '@/shared/config/router';

interface ErrorWidgetProps {
  error?: string;
}

export const ErrorWidget = ({ error }: ErrorWidgetProps) => {
  const navigate = useNavigate();

  const handleReloadPage = () => window.location.reload();
  const handleBackToHome = () => navigate(routerPath.main, { replace: true });

  return (
    <Section
      typeSection="section"
      className="w-full h-full min-h-[500px] flex flex-col items-center justify-center gap-4 py-10"
    >
      <div className="text-center text-red-600">
        <h2 className="text-xl font-medium">Failed to load the page</h2>
        {error && (
          <p className="text-lg">
            Error: <code className="text-black">{error}</code>
          </p>
        )}
      </div>
      <div className="flex gap-x-4">
        <Button onPress={handleReloadPage} color="danger">
          Reload page
        </Button>
        <Button onPress={handleBackToHome} color="primary">
          Back to home
        </Button>
      </div>
    </Section>
  );
};
